import React from 'react';
import compose from 'lodash/fp/compose';
import { connect } from 'react-redux';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { BaseHOC, withBaseHOCProps } from '../common/BaseHOC';
import * as organisationProposalActions from 'actions/organisationProposal';

// let loaded = false;

const initialState = {
  loaded: false,
};

export const withOrganisationProposal = (WrappedComponent) => {
  class WithOrganisationProposal extends BaseHOC {
    state = { ...initialState };

    async componentDidMount() {
      const { getOrganisationProposal } = this.props;
      if (!this.state.loaded) {
        await getOrganisationProposal();
        this.setState({ ...initialState, loaded: true });
        // loaded = true;
      }
    }

    render() {
      return <WrappedComponent {...this.props} loaded={this.state.loaded} />;
    }
  }
  //   const mapStateToProps = ({ organisationProposal: { organisationProposal } }) => ({ organisationProposal });
  const mapStateToProps = ({ organisationProposal }) => ({ organisationProposal });
  const OrganisationProposal = connect(
    mapStateToProps,
    organisationProposalActions,
  )(WithOrganisationProposal);
  hoistNonReactStatics(OrganisationProposal, WrappedComponent);
  return compose(withBaseHOCProps)(OrganisationProposal);
};
